import { render } from "./CollectionSourceDisplayCompact.vue?vue&type=template&id=04b85488&scoped=true"
import script from "./CollectionSourceDisplayCompact.vue?vue&type=script&lang=js"
export * from "./CollectionSourceDisplayCompact.vue?vue&type=script&lang=js"

import "./CollectionSourceDisplayCompact.vue?vue&type=style&index=0&id=04b85488&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b85488"]])

export default __exports__